<app-deprecated-confirmation-dialog
    #confirmationModal
    header="applicant-tracker.confirmBulkEmail"
    description="applicant-tracker.areYouSureYouWantToSendThisMessageToAllApplicants"
    label="applicant-tracker.sendToAll"
>
</app-deprecated-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="applicant-tracker.email-applicants" [back]="true"></app-header>

    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <app-recruiting-applicant-message-form
                    [applicantMessage]="applicantMessage"
                    #applicantMessageForm
                ></app-recruiting-applicant-message-form>
                <div style="display: flex; justify-content: flex-end">
                    <ui-button type="link" (click)="onSendTest(applicantMessageForm)">{{
                        'applicant-tracker.applicants.sendATest' | appTranslate
                    }}</ui-button>
                    <ui-button type="primary" (click)="onSave(applicantMessageForm)">{{
                        'applicant-tracker.send' | appTranslate
                    }}</ui-button>
                </div>
            </div>
        </div>
        <div class="sidebar">
            <app-customization-tokens></app-customization-tokens>
        </div>
    </div>
</div>
